import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  titleContainer: {
    // flexDirection: "row",
    marginTop: 20,
  },
  reportTitle: {
    color: "#000000",
    fontSize: 14,
    textAlign: "center",
    fontWeight: "bold",
  },
});

const ReportTitle = ({ title }) => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>{title}</Text>
  </View>
);

export default ReportTitle;
